import { apiFetch } from './apiFetch';

export interface StaffMemberOption {
  /** Per-box users_boxes_id — same value our `users_boxes.id` PK uses and
   *  what gets stored on the deposit's `depositor_arbox_users_boxes_id`.
   *  Arbox's staff endpoints surface this as `user_id` but it's actually the
   *  per-box association id, not a global user id. */
  arbox_users_boxes_id: number;
  display_name: string;
}

export async function fetchStaffMembers(): Promise<StaffMemberOption[]> {
  return apiFetch<StaffMemberOption[]>('/staff-members');
}

/** Triggers an on-demand re-sync of the box's roster from Arbox and returns
 *  the fresh list. Used by the "איש צוות חסר? לחץ פה לרענון" link in the
 *  new-deposit drawer. */
export async function refreshStaffMembers(): Promise<StaffMemberOption[]> {
  return apiFetch<StaffMemberOption[]>('/staff-members/refresh', { method: 'POST' });
}
